"use client";

import { useEffect, useState } from "react";

const NOTICE_KEY = "sa_notice_dismissed";

export default function ConsentBanner() {
  // Informational notice only (tracking is unconditional). The button simply
  // acknowledges + hides it, and remembers the choice per browser.
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      setShow(localStorage.getItem(NOTICE_KEY) !== "1");
    } catch {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  function dismiss() {
    try {
      localStorage.setItem(NOTICE_KEY, "1");
    } catch {}
    setShow(false);
  }

  return (
    <div
      className="consent-banner"
      role="region"
      aria-label="Cookies and analytics notice"
    >
      <p>
        StaffAble AI uses first-party analytics, Meta Pixel, Meta Conversions
        API, and Microsoft Clarity to understand how visitors use this site and
        improve our services. Learn more in our{" "}
        <a href="/cookie-policy/">Cookie policy</a> and{" "}
        <a href="/privacy/">Privacy policy</a>.
      </p>
      <button
        type="button"
        className="consent-btn consent-dismiss"
        onClick={dismiss}
      >
        Got it
      </button>
    </div>
  );
}
